import React, { Fragment, memo, useCallback, useEffect } from 'react';
import { Container, useTheme, useMediaQuery, Box } from '@material-ui/core';
import {
  CardapioHeaderCapa,
  CardapioHeaderLogo,
  CardapioHeaderText,
} from './componentes';
import { Carregando } from 'components';
import { CardapioHeaderProps } from './cardapio-header-props';
import { useCardapioHeader } from './use-cardapio-header';
import { useStyles } from './cardapio-header-styles';
import classNames from 'classnames';
import { CardapioHeaderInfo } from './componentes/cardapio-header-info';
import { isValidUUIDV4 } from 'utils/is-valid-id';
import { useAtualizarDadosConfig } from 'services/providers/atualizar-configuracoes-tema-provider';

export const CardapioHeader = memo((props: CardapioHeaderProps) => {

  const { className, atualizando } = props;
  // DEPENDECIAS  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // REQUISIÇÕES
  const { dados, operacoes } = useCardapioHeader({ ...props, cardapioDados: props.cardapioDados });
  const { empresa, configuracoes } = dados.cardapioDados

  // STYLES
  const classes = useStyles({
  });

  const { salvarHeader, modelFormatado } = useAtualizarDadosConfig();

  const salvarDados = useCallback(() => {
    if (salvarHeader) {
      salvarHeader(configuracoes);
    }
  }, [salvarHeader, configuracoes])

  useEffect(() => {
    salvarDados();
  }, [salvarDados])

  let mesaIdValido: boolean = isValidUUIDV4(props.mesaId);

  return (
    <Container className={classNames(className, classes.root)} >
      <Fragment>
        <CardapioHeaderCapa
          empresaId={empresa.id}
          height={isMobile ? 'calc(100vh - 200px)' : '75vh'}
          capaUrl={configuracoes.capa ?? ''}
          somenteLeitura={props.visualizacao !== 'configuracao'}
          quandoUmaNovaCapaForSelecionada={operacoes.quandoOsDadosMudarem}
        >
          <CardapioHeaderLogo
            empresaId={empresa.id}
            somenteLeitura={props.visualizacao !== 'configuracao'}
            logoUrl={configuracoes?.logo}
            onLogoChange={operacoes.quandoOsDadosMudarem}
            className={[classes.block, classes.logo].join(' ')}
          />
          <Container fixed maxWidth="md">
            <Box width={"100%"} display={"flex"} justifyContent={"center"}>
              <div>
                <div className={classes.contentPaper}>
                  <CardapioHeaderText
                    text={empresa.nomeFantasia}
                    somenteLeitura
                    editando={dados.editandoNome}
                    quandoEdicaoForIniciada={operacoes.quandoEdicaoNomeForIniciada}
                    tipoEdicao="Nome da Empresa"
                    className={classes.block}
                  />
                  <CardapioHeaderText
                    text={configuracoes?.informacaoAdicional}
                    editando={dados.editandoInformacao}
                    somenteLeitura={props.visualizacao !== 'configuracao'}
                    quandoEdicaoForIniciada={operacoes.quandoEdicaoInformacoesIniciada}
                    quandoTextoForAlterado={operacoes.quandoInformacoesForAlterada}
                    tipoEdicao="Informações"
                    strong={false}
                    className={classes.informacaoAdicional}
                    submitEditar={() => modelFormatado(configuracoes)}
                    variant="body1"
                  />
                  {props.visualizacao !== 'configuracao' && (
                    <CardapioHeaderInfo
                      empresa={dados.cardapioDados}
                      idValido={mesaIdValido}
                    />
                  )}
                </div>
              </div>
            </Box>
          </Container>
          <Carregando
            carregando={atualizando || dados.carregando}
            modelo="absolute"
            titulo={atualizando ? 'Atualizando Capa' : 'Buscando Informações'}
            mensagem={
              atualizando
                ? 'Aguarde enquanto atualizamos as configurações do seu estabelecimento.'
                : ''
            }
            className={classes.carregando}
          />
        </CardapioHeaderCapa>
      </Fragment>
    </Container>
  );
});

CardapioHeader.displayName = 'CardapioHeader';

